import { toast } from "sonner";

function messageFor(err: unknown, fallback: string): string {
  if (err instanceof Error && err.message) {
    return err.message;
  }

  return fallback;
}

export const notify = {
  success(message: string) {
    toast.success(message);
  },

  error(message: string) {
    toast.error(message);
  },

  info(message: string) {
    toast.info(message);
  },

  fromError(err: unknown, fallback: string) {
    toast.error(messageFor(err, fallback));
  },

  promise<T>(
    promise: Promise<T>,
    messages: {
      loading: string;
      success: string | ((value: T) => string);
      error: string | ((err: unknown) => string);
    },
  ) {
    return toast.promise(promise, messages);
  },
};
